import ClassNames from "classnames";
import { FunctionComponent } from "react";
import globalTranslations from "../../i18n/index.js";
import styles from "../../stylesheets/components/header-mobile/circle-hamburger-button.module.css";
import { Language } from "../../types/index.js";
import { getTranslations } from "../../utils/utils.js";

interface Props {
  isMenuOpen: boolean;
  languageId: Language;
  onClick: () => void;
}

const CircleHamburgerButton: FunctionComponent<Props> = ({
  isMenuOpen,
  languageId,
  onClick,
}) => {
  const i18n = getTranslations(languageId, globalTranslations);

  return (
    <button
      type="button"
      className={ClassNames(styles.CircleHamburgerButton, {
        [styles["CircleHamburgerButton--open"]]: isMenuOpen,
      })}
      onClick={onClick}
      aria-label={isMenuOpen ? i18n.menu.close : i18n.menu.open}
    >
      <span className={styles.CircleHamburgerButton__Inner}>
        <span className={styles.CircleHamburgerButton__Icon}>
          <span
            className={ClassNames(
              styles.CircleHamburgerButton__Line,
              styles.CircleHamburgerButton__Line1,
            )}
          ></span>
          <span
            className={ClassNames(
              styles.CircleHamburgerButton__Line,
              styles.CircleHamburgerButton__Line2,
            )}
          ></span>
          <span
            className={ClassNames(
              styles.CircleHamburgerButton__Line,
              styles.CircleHamburgerButton__Line3,
            )}
          ></span>
          <span
            className={ClassNames(
              styles.CircleHamburgerButton__Line,
              styles.CircleHamburgerButton__Line4,
            )}
          ></span>
        </span>
      </span>
    </button>
  );
};

export default CircleHamburgerButton;
